import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
// pages
import BlogPost from "@/views/examples/BlogPost.js";
import BlogPosts from "@/views/examples/BlogPosts.js";
import ContactUs from "@/views/examples/ContactUs.js";
import Ecommerce from "@/views/examples/Ecommerce.js";
import Index from "@/views/Index.js";
import LandingPage from "@/views/examples/LandingPage.js";
import LoginPage from "@/views/examples/LoginPage.js";
import NucleoIcons from "@/views/NucleoIcons.js";
import Presentation from "@/views/Presentation.js";
import Pricing from "@/views/examples/Pricing.js";
import ProductPage from "@/views/examples/ProductPage.js";
import ProfilePage from "@/views/examples/ProfilePage.js";
import Sections from "@/views/Sections.js";
import SignupPage from "@/views/examples/SignupPage.js";
import HomePage from "@/pages/Home/HomePage";
import AboutUs from "@/pages/About/AboutUs";
// others
import "./il8n";
import { Provider } from "react-redux";
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client'
// @ts-ignore
import { store } from "./redux/store";
import { useSelector } from "react-redux";
// @ts-ignore
import { selectLanguage } from "./redux/state/language";
import '@fortawesome/fontawesome-svg-core/styles.css'
import "@apollo/space-kit/reset.css";

const client = new ApolloClient({
  // uri: 'http://localhost:4000',
  uri: 'https://zdjav2eqbrevbgleqgffiu6aoe.appsync-api.eu-south-1.amazonaws.com/graphql',
  cache: new InMemoryCache(),
  headers: {
    'x-api-key': "da2-h5niovxnvvafne46ckzhkskp3y"
  }
})

export default function App() {
  return (
    <Suspense fallback="Loading...">
      <ApolloProvider client={client}>
        <Provider store={store}>
          <Routes />
        </Provider>
      </ApolloProvider>
    </Suspense>
  );
}

function Routes() {
  // @ts-ignore
  const { currentLanguage } = useSelector(selectLanguage);
  useEffect(() => {
    const direction = currentLanguage === "ar" ? "rtl" : "ltr"
    const body = document.getElementById('root')!
    body.style.direction = direction
  }, [currentLanguage])

  return (
    // @ts-ignore
    <BrowserRouter>
      <Switch>
        <Route path="/about-us" render={() => <AboutUs />} />
        <Route
          path="/blog-post"
          render={(props) => <BlogPost {...props} />}
        />
        <Route
          path="/blog-posts"
          render={(props) => <BlogPosts {...props} />}
        />
        <Route
          path="/contact-us"
          render={(props) => <ContactUs {...props} />}
        />
        <Route
          path="/e-commerce"
          render={(props) => <Ecommerce {...props} />}
        />
        <Route path="/index" render={(props) => <Index {...props} />} />
        <Route
          path="/landing-page"
          render={(props) => <LandingPage {...props} />}
        />
        <Route
          path="/login-page"
          render={(props) => <LoginPage {...props} />}
        />
        <Route
          path="/nucleo-icons"
          render={(props) => <NucleoIcons {...props} />}
        />
        <Route
          path="/presentation"
          render={(props) => <Presentation {...props} />}
        />
        <Route path="/pricing" render={(props) => <Pricing {...props} />} />
        <Route
          path="/product-page"
          render={(props) => <ProductPage {...props} />}
        />
        <Route
          path="/profile-page"
          render={(props) => <ProfilePage {...props} />}
        />
        <Route path="/sections" render={(props) => <Sections {...props} />} />
        <Route
          path="/sign-up"
          render={(props) => <SignupPage {...props} />}
        />
        <Route path="/" render={() => <HomePage />} />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
}
